import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'
// 加载动态设置REM基准值
import 'amfe-flexible'

import { Message } from 'element-ui'
import Element from 'element-ui'
import { MessageBox } from 'element-ui'
import './styles/element-variables.scss'
import preventReClick from './utils/preventReClick'
import './icons' // icon
// 引入全局的css样式
import './styles/index.less'

import veaDialog from '@components/common/veaDialog'
import '../static/ueditor/ueditor.config.js' 
import '../static/ueditor/ueditor.all.js' 
import '../static/ueditor/lang/zh-cn/zh-cn.js' 
import '../static/ueditor/ueditor.parse.min.js'
import Vue2OrgTree from 'vue-tree-color'
Vue.component('veaDialog', veaDialog)
Vue.use(Vue2OrgTree)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.use(Element, {
  // size: 'small'
})

// 导航守卫
router.beforeEach((to, from, next) => {
  let userInfo = sessionStorage.getItem('userInfo')
  let $userInfo = null
  if (userInfo) {
    $userInfo = JSON.parse(userInfo)
  }
  let username = $userInfo ? $userInfo.name : '',
    userid = $userInfo ? $userInfo.autoid : -1,
    customerid = $userInfo ? $userInfo.customerid : -1
  Vue.prototype.$userInfo = $userInfo
  if (
    (!userInfo || customerid != 0 || !userid) &&
    to.path.toLowerCase() != '/login'
  ) {
    next('/login')
    Message.error('当前账号没有权限，请重新登录！')
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
